import { render, staticRenderFns } from "./DisableTab.vue?vue&type=template&id=0f1ac8b5&scoped=true&"
import script from "./DisableTab.vue?vue&type=script&lang=js&"
export * from "./DisableTab.vue?vue&type=script&lang=js&"
import style0 from "./DisableTab.vue?vue&type=style&index=0&id=0f1ac8b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1ac8b5",
  null
  
)

export default component.exports